import React from 'react';
import { GoogleAnalyticsReportBottomContent } from '../../../modules/GoogleAnalytics';
export const getExternalSourceBottomContent = (externalSource, uri) => {
    if (externalSource === 'google-analytics') {
        return React.createElement(GoogleAnalyticsReportBottomContent, { href: uri });
    }
};
